export function parseNumberTo2Decimals(value: number) {
    const with2Decimals = new RegExp(/^-?\d+(?:\.\d{0,2})?/);
    return with2Decimals.exec(String(value))?.[0];
}
